[
 {
  "ganZhi": "甲子",
  "hangul": "갑자",
  "roman": "gap-ja",
  "stemElement": "wood",
  "branchElement": "water"
 },
 {
  "ganZhi": "乙丑",
  "hangul": "을축",
  "roman": "eul-chuk",
  "stemElement": "wood",
  "branchElement": "earth"
 },
 {
  "ganZhi": "丙寅",
  "hangul": "병인",
  "roman": "byeong-in",
  "stemElement": "fire",
  "branchElement": "wood"
 },
 {
  "ganZhi": "丁卯",
  "hangul": "정묘",
  "roman": "jeong-myo",
  "stemElement": "fire",
  "branchElement": "wood"
 },
 {
  "ganZhi": "戊辰",
  "hangul": "무진",
  "roman": "mu-jin",
  "stemElement": "earth",
  "branchElement": "earth"
 },
 {
  "ganZhi": "己巳",
  "hangul": "기사",
  "roman": "gi-sa",
  "stemElement": "earth",
  "branchElement": "fire"
 },
 {
  "ganZhi": "庚午",
  "hangul": "경오",
  "roman": "gyeong-o",
  "stemElement": "metal",
  "branchElement": "fire"
 },
 {
  "ganZhi": "辛未",
  "hangul": "신미",
  "roman": "sin-mi",
  "stemElement": "metal",
  "branchElement": "earth"
 },
 {
  "ganZhi": "壬申",
  "hangul": "임신",
  "roman": "im-sin",
  "stemElement": "water",
  "branchElement": "metal"
 },
 {
  "ganZhi": "癸酉",
  "hangul": "계유",
  "roman": "gye-yu",
  "stemElement": "water",
  "branchElement": "metal"
 },
 {
  "ganZhi": "甲戌",
  "hangul": "갑술",
  "roman": "gap-sul",
  "stemElement": "wood",
  "branchElement": "earth"
 },
 {
  "ganZhi": "乙亥",
  "hangul": "을해",
  "roman": "eul-hae",
  "stemElement": "wood",
  "branchElement": "water"
 },
 {
  "ganZhi": "丙子",
  "hangul": "병자",
  "roman": "byeong-ja",
  "stemElement": "fire",
  "branchElement": "water"
 },
 {
  "ganZhi": "丁丑",
  "hangul": "정축",
  "roman": "jeong-chuk",
  "stemElement": "fire",
  "branchElement": "earth"
 },
 {
  "ganZhi": "戊寅",
  "hangul": "무인",
  "roman": "mu-in",
  "stemElement": "earth",
  "branchElement": "wood"
 },
 {
  "ganZhi": "己卯",
  "hangul": "기묘",
  "roman": "gi-myo",
  "stemElement": "earth",
  "branchElement": "wood"
 },
 {
  "ganZhi": "庚辰",
  "hangul": "경진",
  "roman": "gyeong-jin",
  "stemElement": "metal",
  "branchElement": "earth"
 },
 {
  "ganZhi": "辛巳",
  "hangul": "신사",
  "roman": "sin-sa",
  "stemElement": "metal",
  "branchElement": "fire"
 },
 {
  "ganZhi": "壬午",
  "hangul": "임오",
  "roman": "im-o",
  "stemElement": "water",
  "branchElement": "fire"
 },
 {
  "ganZhi": "癸未",
  "hangul": "계미",
  "roman": "gye-mi",
  "stemElement": "water",
  "branchElement": "earth"
 },
 {
  "ganZhi": "甲申",
  "hangul": "갑신",
  "roman": "gap-sin",
  "stemElement": "wood",
  "branchElement": "metal"
 },
 {
  "ganZhi": "乙酉",
  "hangul": "을유",
  "roman": "eul-yu",
  "stemElement": "wood",
  "branchElement": "metal"
 },
 {
  "ganZhi": "丙戌",
  "hangul": "병술",
  "roman": "byeong-sul",
  "stemElement": "fire",
  "branchElement": "earth"
 },
 {
  "ganZhi": "丁亥",
  "hangul": "정해",
  "roman": "jeong-hae",
  "stemElement": "fire",
  "branchElement": "water"
 },
 {
  "ganZhi": "戊子",
  "hangul": "무자",
  "roman": "mu-ja",
  "stemElement": "earth",
  "branchElement": "water"
 },
 {
  "ganZhi": "己丑",
  "hangul": "기축",
  "roman": "gi-chuk",
  "stemElement": "earth",
  "branchElement": "earth"
 },
 {
  "ganZhi": "庚寅",
  "hangul": "경인",
  "roman": "gyeong-in",
  "stemElement": "metal",
  "branchElement": "wood"
 },
 {
  "ganZhi": "辛卯",
  "hangul": "신묘",
  "roman": "sin-myo",
  "stemElement": "metal",
  "branchElement": "wood"
 },
 {
  "ganZhi": "壬辰",
  "hangul": "임진",
  "roman": "im-jin",
  "stemElement": "water",
  "branchElement": "earth"
 },
 {
  "ganZhi": "癸巳",
  "hangul": "계사",
  "roman": "gye-sa",
  "stemElement": "water",
  "branchElement": "fire"
 },
 {
  "ganZhi": "甲午",
  "hangul": "갑오",
  "roman": "gap-o",
  "stemElement": "wood",
  "branchElement": "fire"
 },
 {
  "ganZhi": "乙未",
  "hangul": "을미",
  "roman": "eul-mi",
  "stemElement": "wood",
  "branchElement": "earth"
 },
 {
  "ganZhi": "丙申",
  "hangul": "병신",
  "roman": "byeong-sin",
  "stemElement": "fire",
  "branchElement": "metal"
 },
 {
  "ganZhi": "丁酉",
  "hangul": "정유",
  "roman": "jeong-yu",
  "stemElement": "fire",
  "branchElement": "metal"
 },
 {
  "ganZhi": "戊戌",
  "hangul": "무술",
  "roman": "mu-sul",
  "stemElement": "earth",
  "branchElement": "earth"
 },
 {
  "ganZhi": "己亥",
  "hangul": "기해",
  "roman": "gi-hae",
  "stemElement": "earth",
  "branchElement": "water"
 },
 {
  "ganZhi": "庚子",
  "hangul": "경자",
  "roman": "gyeong-ja",
  "stemElement": "metal",
  "branchElement": "water"
 },
 {
  "ganZhi": "辛丑",
  "hangul": "신축",
  "roman": "sin-chuk",
  "stemElement": "metal",
  "branchElement": "earth"
 },
 {
  "ganZhi": "壬寅",
  "hangul": "임인",
  "roman": "im-in",
  "stemElement": "water",
  "branchElement": "wood"
 },
 {
  "ganZhi": "癸卯",
  "hangul": "계묘",
  "roman": "gye-myo",
  "stemElement": "water",
  "branchElement": "wood"
 },
 {
  "ganZhi": "甲辰",
  "hangul": "갑진",
  "roman": "gap-jin",
  "stemElement": "wood",
  "branchElement": "earth"
 },
 {
  "ganZhi": "乙巳",
  "hangul": "을사",
  "roman": "eul-sa",
  "stemElement": "wood",
  "branchElement": "fire"
 },
 {
  "ganZhi": "丙午",
  "hangul": "병오",
  "roman": "byeong-o",
  "stemElement": "fire",
  "branchElement": "fire"
 },
 {
  "ganZhi": "丁未",
  "hangul": "정미",
  "roman": "jeong-mi",
  "stemElement": "fire",
  "branchElement": "earth"
 },
 {
  "ganZhi": "戊申",
  "hangul": "무신",
  "roman": "mu-sin",
  "stemElement": "earth",
  "branchElement": "metal"
 },
 {
  "ganZhi": "己酉",
  "hangul": "기유",
  "roman": "gi-yu",
  "stemElement": "earth",
  "branchElement": "metal"
 },
 {
  "ganZhi": "庚戌",
  "hangul": "경술",
  "roman": "gyeong-sul",
  "stemElement": "metal",
  "branchElement": "earth"
 },
 {
  "ganZhi": "辛亥",
  "hangul": "신해",
  "roman": "sin-hae",
  "stemElement": "metal",
  "branchElement": "water"
 },
 {
  "ganZhi": "壬子",
  "hangul": "임자",
  "roman": "im-ja",
  "stemElement": "water",
  "branchElement": "water"
 },
 {
  "ganZhi": "癸丑",
  "hangul": "계축",
  "roman": "gye-chuk",
  "stemElement": "water",
  "branchElement": "earth"
 },
 {
  "ganZhi": "甲寅",
  "hangul": "갑인",
  "roman": "gap-in",
  "stemElement": "wood",
  "branchElement": "wood"
 },
 {
  "ganZhi": "乙卯",
  "hangul": "을묘",
  "roman": "eul-myo",
  "stemElement": "wood",
  "branchElement": "wood"
 },
 {
  "ganZhi": "丙辰",
  "hangul": "병진",
  "roman": "byeong-jin",
  "stemElement": "fire",
  "branchElement": "earth"
 },
 {
  "ganZhi": "丁巳",
  "hangul": "정사",
  "roman": "jeong-sa",
  "stemElement": "fire",
  "branchElement": "fire"
 },
 {
  "ganZhi": "戊午",
  "hangul": "무오",
  "roman": "mu-o",
  "stemElement": "earth",
  "branchElement": "fire"
 },
 {
  "ganZhi": "己未",
  "hangul": "기미",
  "roman": "gi-mi",
  "stemElement": "earth",
  "branchElement": "earth"
 },
 {
  "ganZhi": "庚申",
  "hangul": "경신",
  "roman": "gyeong-sin",
  "stemElement": "metal",
  "branchElement": "metal"
 },
 {
  "ganZhi": "辛酉",
  "hangul": "신유",
  "roman": "sin-yu",
  "stemElement": "metal",
  "branchElement": "metal"
 },
 {
  "ganZhi": "壬戌",
  "hangul": "임술",
  "roman": "im-sul",
  "stemElement": "water",
  "branchElement": "earth"
 },
 {
  "ganZhi": "癸亥",
  "hangul": "계해",
  "roman": "gye-hae",
  "stemElement": "water",
  "branchElement": "water"
 }
]
